/* eslint-disable */

import data from '@data/data';

const apiKey = process.env.REACT_APP_API_KEY;
const baseEndpoint = process.env.REACT_APP_API_BASE_ENDPOINT;
const findTakerEndpoint = `${baseEndpoint}${process.env.REACT_APP_API_FIND_TAKER_API}`;
const surveysEndpoint = `${baseEndpoint}${process.env.REACT_APP_API_SURVEYS_API}`;
const surveyByTakerEndpoint = `${baseEndpoint}${process.env.REACT_APP_API_SURVEY_BY_TAKER_API}`;

async function findTaker(email) {
  const response = await fetch(
    `${findTakerEndpoint}?populate=surveys&filters[email][$eq]=${email}`,
    {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    }
  );
  const json = await response.json();

  return json;
}

async function postTaker({ firstName, lastName, companyName, emailAddress }) {
  const response = await fetch(`${findTakerEndpoint}`, {
    method: 'POST',
    body: JSON.stringify({
      data: {
        email: emailAddress,
        name: [firstName, lastName].join(' '),
        company: companyName,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`,
    },
  });
  const json = await response.json();

  return json;
}

async function postSurveyByTaker(emailAddress) {
  const response = await fetch(`${surveyByTakerEndpoint}`, {
    method: 'POST',
    body: JSON.stringify({
      data: {
        email: emailAddress,
      },
    }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`,
    },
  });
  const json = await response.json();

  return json;
}

function getAnswer(
  pillarsStore,
  pillarIndex,
  optionIndex,
  questionIndex,
  useIndex,
  answerIndex,
  question
) {
  const item =
    pillarsStore[pillarIndex].answers[optionIndex || 0].value.find((item) => {
      if (question) {
        return item.question === question;
      }

      return (
        item.questionIndex === questionIndex || item.answerIndex === answerIndex
      );
    }) || {};

  return (useIndex ? item.answerIndex : item.answer) || 0;
}

function remapCustomers(customers) {
  const map = {
    '< 5 million': 'C_5_million',
    '5 to 25 million': 'C_5_to_25_million',
    '25 to 50 million': 'C_25_to_50_million',
    '50 to 100 million': 'C_50_to_100_million',
    '> 100 million': 'C_100_million',
  };

  for (const key in map) {
    map[map[key]] = key;
  }

  return map[customers];
}

function encodeSurvey(pillarsStore, taker_id) {
  return {
    pillar00: {
      region: getAnswer(pillarsStore, 0, 0, 0),
      customers_count: remapCustomers(getAnswer(pillarsStore, 0, 0, 1)),
      ai_responsibilities: getAnswer(pillarsStore, 0, 0, 2),
    },
    pillar01: {
      question1: getAnswer(pillarsStore, 1, 0, 0) === 'Yes',
      question2: getAnswer(pillarsStore, 1, 1, 1, true),
      question3: getAnswer(pillarsStore, 1, 2, 2, true),
      question4: getAnswer(pillarsStore, 1, 3, 3, true),
    },
    pillar02: {
      question1: getAnswer(pillarsStore, 2, 0, 0, true),
      question2: getAnswer(pillarsStore, 2, 1, 1) === 'Yes',
      question3: getAnswer(pillarsStore, 2, 2, 2) === 'Yes',
      question4: getAnswer(pillarsStore, 2, 3, 3) === 'Yes',
    },
    pillar03: {
      question1: {
        question1: parseInt(
          getAnswer(pillarsStore, 3, 0, 0, false, 0, 'Rapid access to the data')
        ),
        question2: parseInt(
          getAnswer(
            pillarsStore,
            3,
            0,
            1,
            false,
            1,
            'Access to trustworthy data'
          )
        ),
        question3: parseInt(
          getAnswer(
            pillarsStore,
            3,
            0,
            2,
            false,
            2,
            'Access to high-quality structured data'
          )
        ),
        question4: parseInt(
          getAnswer(
            pillarsStore,
            3,
            0,
            3,
            false,
            3,
            'Access to high-quality unstructured data'
          )
        ),
        question5: parseInt(
          getAnswer(pillarsStore, 3, 0, 4, false, 4, 'Access to streaming data')
        ),
      },
    },
    pillar04: {
      question1: {
        question1: getAnswer(pillarsStore, 4, 0, 0, false, 0) === 'yes',
        question2: getAnswer(pillarsStore, 4, 0, 1, false, 1) === 'yes',
        question3: getAnswer(pillarsStore, 4, 0, 2, false, 2) === 'yes',
        question4: getAnswer(pillarsStore, 4, 0, 3, false, 3) === 'yes',
      },
    },
    pillar05: {
      question1: {
        chatbots: getAnswer(pillarsStore, 5, 0, 0, false, 0),
        summarization: getAnswer(pillarsStore, 5, 0, 1, false, 1),
        document_creation: getAnswer(pillarsStore, 5, 0, 2, false, 2),
        code_creation: getAnswer(pillarsStore, 5, 0, 3, false, 3),
        content_creation: getAnswer(pillarsStore, 5, 0, 4, false, 4),
      },
      question2: {
        it_function: getAnswer(pillarsStore, 5, 1, 0, false, 0),
        network_operation: getAnswer(pillarsStore, 5, 1, 1, false, 1),
        sales_and_marketing: getAnswer(pillarsStore, 5, 1, 2, false, 2),
        product_organizations: getAnswer(pillarsStore, 5, 1, 3, false, 3),
      },
    },
    pillar06: {
      question1: getAnswer(pillarsStore, 6, 0, 0, true),
      question2: getAnswerIndex(6, 1, getAnswer(pillarsStore, 6, 1, 1)),
      question3: getAnswer(pillarsStore, 6, 2, 2, true),
    },
    taker: {
      id: taker_id,
    },
  };
}

function getAnswerIndex(pillarIndex, questionIndex, answer) {
  const question =
    data.the_assessment.content[0].pillars[pillarIndex].questions[
      questionIndex
    ];

  let answers = [];

  if (question.answerLabels) {
    answers = question.answerLabels.map(({ value }) => value).filter(Boolean);
  } else {
    answers = question.answers.map(({ text }) => text).filter(Boolean);
  }

  if (!answers.length) {
    answers = question.answers[0].options
      .map(({ value }) => value)
      .filter(Boolean);
  }

  return answers.indexOf(answer);
}

function getAnswerByIndex(pillarIndex, questionIndex, answerIndex) {
  const question =
    data.the_assessment.content[0].pillars[pillarIndex].questions[
      questionIndex
    ];

  if (question.answers[0].options) {
    return question.answers[0].options[answerIndex].value;
  }

  return question.answers[answerIndex]?.text || '';
}

export function decodeSurvey(surveyData) {
  return [
    {
      answers: [
        {
          id: 1,
          value: [
            {
              answer: surveyData.pillar00.region,
              answerIndex: getAnswerIndex(0, 0, surveyData.pillar00.region),
              question: 'In which region are you based?',
              questionIndex: 0,
            },
            {
              answer: remapCustomers(surveyData.pillar00.customers_count),
              answerIndex: getAnswerIndex(
                0,
                1,
                remapCustomers(surveyData.pillar00.customers_count)
              ),
              question: 'How many customers are served by your organization?',
              questionIndex: 1,
            },
            {
              answer: surveyData.pillar00.ai_responsibilities,
              answerIndex: getAnswerIndex(
                0,
                2,
                surveyData.pillar00.ai_responsibilities
              ),
              question: 'What are your responsibilities with respect to AI?',
              questionIndex: 2,
            },
          ],
        },
      ],
      id: 1,
    },
    {
      answers: [
        {
          id: 1,
          value: [
            {
              answer: surveyData.pillar01.question1 ? 'Yes' : 'No',
              answerIndex: surveyData.pillar01.question1 ? 0 : 1,
              question:
                'Do you believe that your organization has the right skills to select the right model for the right use case?',
              questionIndex: 0,
            },
          ],
        },
        {
          id: 2,
          value: [
            {
              answer: getAnswerByIndex(1, 1, surveyData.pillar01.question2),
              answerIndex: surveyData.pillar01.question2,
              question:
                'How would you assess your ability to use different techniques (RAG, prompt engineering, fine tuning etc) for getting the most accurate results for different use cases?',
              questionIndex: 1,
            },
          ],
        },
        {
          id: 3,
          value: [
            {
              answer: getAnswerByIndex(1, 2, surveyData.pillar01.question3),
              answerIndex: surveyData.pillar01.question3,
              question:
                'How would you assess your capabilities for assessing the cost and ROI of using different techniques (RAG, prompt engineering, fine tuning etc) for different use cases?',
              questionIndex: 2,
            },
          ],
        },
        {
          id: 4,
          value: [
            {
              answer: getAnswerByIndex(1, 3, surveyData.pillar01.question4),
              answerIndex: surveyData.pillar01.question4,
              question:
                'Which of the following levels of MLOps maturity most closely aligns with your organization?',
              questionIndex: 3,
            },
          ],
        },
      ],
      id: 2,
    },
    {
      answers: [
        {
          id: 1,
          value: [
            {
              answer: getAnswerByIndex(2, 0, surveyData.pillar02.question1),
              answerIndex: surveyData.pillar02.question1,
              question:
                'When it comes to hiring and reskilling in specific areas relating to GenAI (eg prompt engineering) which of the following statements most closely aligns with your organization?',
              questionIndex: 0,
            },
          ],
        },
        {
          id: 2,
          value: [
            {
              answer: surveyData.pillar02.question2 ? 'Yes' : 'No',
              answerIndex: surveyData.pillar02.question2 ? 0 : 1,
              question:
                'Do you have a CXO (for example a Chief Digital Officer or a Chief AI Officer) role whose time and responsibilities are predominantly (more than 50%) focussed on AI?',
              questionIndex: 1,
            },
          ],
        },
        {
          id: 3,
          value: [
            {
              answer: surveyData.pillar02.question3 ? 'Yes' : 'No',
              answerIndex: surveyData.pillar02.question3 ? 0 : 1,
              question:
                'Do you have a central AI office / center of excellence that is responsible for AI governance?',
              questionIndex: 2,
            },
          ],
        },
        {
          id: 4,
          value: [
            {
              answer: surveyData.pillar02.question4 ? 'Yes' : 'No',
              answerIndex: surveyData.pillar02.question4 ? 0 : 1,
              question:
                'Do you have dedicated AI roles and accountabilities in different parts of the business (eg product, network, marketing)?',
              questionIndex: 3,
            },
          ],
        },
      ],
      id: 3,
    },
    {
      answers: [
        {
          id: 1,
          value: [
            {
              answer: String(surveyData.pillar03.question1.question1),
              answerIndex: 0,
              question: 'Rapid access to the data',
              questionIndex: 0,
            },
            {
              answer: String(surveyData.pillar03.question1.question2),
              answerIndex: 1,
              question: 'Access to trustworthy data',
              questionIndex: 0,
            },
            {
              answer: String(surveyData.pillar03.question1.question3),
              answerIndex: 2,
              question: 'Access to high-quality structured data',
              questionIndex: 0,
            },
            {
              answer: String(surveyData.pillar03.question1.question4),
              answerIndex: 3,
              question: 'Access to high-quality unstructured data',
              questionIndex: 0,
            },
            {
              answer: String(surveyData.pillar03.question1.question5),
              answerIndex: 4,
              question: 'Access to streaming data',
              questionIndex: 0,
            },
          ],
        },
      ],
      id: 4,
    },
    {
      answers: [
        {
          id: 1,
          value: [
            {
              answer: surveyData.pillar04.question1.question1 ? 'yes' : 'no',
              answerIndex: 0,
              question:
                'A GenAI platform that handles aspects relating to security / compliance / cost issues',
              questionIndex: 0,
            },
            {
              answer: surveyData.pillar04.question1.question2 ? 'yes' : 'no',
              answerIndex: 1,
              question:
                'A cross-functional GenAI center of excellence (COE) to supplement a central function',
              questionIndex: 0,
            },
            {
              answer: surveyData.pillar04.question1.question3 ? 'yes' : 'no',
              answerIndex: 2,
              question:
                'A core governing body, including an ultimate decision-maker for the organization’s GenAI agenda',
              questionIndex: 0,
            },
            {
              answer: surveyData.pillar04.question1.question4 ? 'yes' : 'no',
              answerIndex: 3,
              question:
                'A well-defined process / policy that reviews the model / use cases and addresses potential negative impact',
              questionIndex: 0,
            },
          ],
        },
      ],
      id: 5,
    },
    {
      answers: [
        {
          id: 1,
          value: [
            {
              answer: surveyData.pillar05.question1.chatbots,
              answerIndex: 0,
              question: 'Chatbots',
              questionIndex: 0,
            },
            {
              answer: surveyData.pillar05.question1.summarization,
              answerIndex: 1,
              question: 'Summarization',
              questionIndex: 0,
            },
            {
              answer: surveyData.pillar05.question1.document_creation,
              answerIndex: 2,
              question: 'Document creation',
              questionIndex: 0,
            },
            {
              answer: surveyData.pillar05.question1.code_creation,
              answerIndex: 3,
              question: 'Code creation',
              questionIndex: 0,
            },
            {
              answer: surveyData.pillar05.question1.content_creation,
              answerIndex: 4,
              question: 'Content creation',
              questionIndex: 0,
            },
          ],
        },
        {
          id: 2,
          value: [
            {
              answer: surveyData.pillar05.question2.it_function,
              answerIndex: 0,
              question: 'IT function',
              questionIndex: 1,
            },
            {
              answer: surveyData.pillar05.question2.network_operation,
              answerIndex: 1,
              question: 'Network operations',
              questionIndex: 1,
            },
            {
              answer: surveyData.pillar05.question2.sales_and_marketing,
              answerIndex: 2,
              question: 'Sales and marketing',
              questionIndex: 1,
            },
            {
              answer: surveyData.pillar05.question2.product_organizations,
              answerIndex: 3,
              question:
                'Product organizations (for the creation of new / enhanced products)',
              questionIndex: 1,
            },
          ],
        },
      ],
      id: 6,
    },
    {
      answers: [
        {
          id: 1,
          value: [
            {
              answer: getAnswerByIndex(6, 0, surveyData.pillar06.question1),
              answerIndex: surveyData.pillar06.question1,
              question:
                'Where are you today in terms of putting GenAI use cases into production?',
              questionIndex: 0,
            },
          ],
        },
        {
          id: 2,
          value: [
            {
              answer: getAnswerByIndex(6, 1, surveyData.pillar06.question2),
              answerIndex: surveyData.pillar06.question2,
              question: 'How many GenAI use cases do you have in production?',
              questionIndex: 1,
            },
          ],
        },
        {
          id: 3,
          value: [
            {
              answer: getAnswerByIndex(6, 2, surveyData.pillar06.question3),
              answerIndex: surveyData.pillar06.question3,
              question:
                'For the POCs that have moved into production, which of the following statements is closest to how you have approached your choice of LLM and how you have gone about achieving the best results?',
              questionIndex: 2,
            },
          ],
        },
      ],
      id: 7,
    },
  ];
}

async function postSurvey(surveyData) {
  const response = await fetch(surveysEndpoint, {
    method: 'POST',
    body: JSON.stringify({ data: surveyData }),
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${apiKey}`,
    },
  });
  const json = await response.json();
  const { data } = json;

  return data?.id || 0;
}

export async function submitSurvey({
  firstName = '',
  lastName = '',
  companyName = '',
  emailAddress = '',
  privacyPolicy = false,
  pillarsStore = {},
}) {
  const response = {
    success: false,
  };

  if (!emailAddress) {
    response.error = 'Email address is required';

    return response;
  }

  try {
    const taker = await postTaker({
      firstName,
      lastName,
      companyName,
      emailAddress,
    });

    const surveyData = encodeSurvey(pillarsStore, taker.data?.id);
    const survey = await postSurvey(surveyData);

    if (survey?.error?.status === 400) {
      response.error = survey?.error?.message || 'Error saving survey';
    }

    if (survey) {
      response.success = true;
    }

    return response;
  } catch (error) {
    response.error = 'Error saving survey';

    return response;
  }
}

async function fetchSurvey(id) {
  const response = await fetch(
    `${surveysEndpoint}/${id}?${[
      'populate[pillar00]=*',
      'populate[pillar01]=*',
      'populate[pillar02]=*',
      'populate[pillar03][populate]=*',
      'populate[pillar04][populate]=*',
      'populate[pillar05][populate]=*',
      'populate[pillar06]=*',
      'populate[taker]=*',
    ].join('&')}`,
    {
      headers: {
        Authorization: `Bearer ${apiKey}`,
      },
    }
  );
  const json = await response.json();

  return json;
}

export async function getSurvey(emailAddress) {
  if (!emailAddress) {
    return false;
  }

  try {
    const taker = await findTaker(emailAddress);

    if (!taker.data.length) {
      return false;
    }

    const surveys = taker.data[0].attributes.surveys.data;

    const surveyId = surveys[surveys.length - 1]?.id || false;

    if (!surveyId) {
      return false;
    }

    try {
      const survey = await fetchSurvey(surveyId);
      if (!survey) {
        return false;
      }

      return survey.data.attributes;
    } catch (error) {
      return false;
    }
  } catch (error) {
    return false;
  }
}

export async function submitSurveyByTaker(emailAddress) {
  if (!emailAddress) {
    return false;
  }

  try {
    const taker = await postSurveyByTaker(emailAddress);

    if (!taker.data.length) {
      console.error('No email address found');
      return false;
    }

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
}
